import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import Marquee from "../marquee/marquee";
import img1 from "../../../assets/resp-1.png";
import img2 from "../../../assets/resp-2.png";
import img3 from "../../../assets/resp-3.png";
import img4 from "../../../assets/resp-4.png";

const responsibilities = [
  {
    number: 1,
    img: img1,
    title: "Advertise",
    description:
      "Publicise Spirit and its sponsors in your college by sharing posts and promoting content by becoming a focal point for your respective college.",
  },
  {
    number: 2,
    img: img2,
    title: "Organise",
    description:
      "With the vision to bring out the leader in you, IIT Guwahati Spirit presents the Campus Ambassador Program.",
  },
  {
    number: 3,
    img: img3,
    title: "Conduct",
    description:
      "Help in management of elimination rounds in your college and city to select participants for the main event",
  },
  {
    number: 4,
    img: img4,
    title: "Coordinate",
    description:
      "Collaborate with the Spirit team in organising on-ground events in your city.",
  },
];

export default function Caresponsibility() {
  const listRef = useRef(null);
  const rowRefs = useRef([]);
  const imageRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            gsap.to(rowRefs.current, {
              y: 0,
              opacity: 1,
              duration: 1.2,
              stagger: 0.12,
              ease: "power3.out",
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05 },
    );

    if (listRef.current) {
      observer.observe(listRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleMouseEnter = (index) => {
    gsap.to(imageRefs.current[index], {
      scale: 1,
      autoAlpha: 1,
      duration: 0.6,
      ease: "back.out(1.4)",
      overwrite: "auto",
    });
  };

  const handleMouseLeave = (index) => {
    gsap.to(imageRefs.current[index], {
      scale: 0,
      autoAlpha: 0,
      duration: 0.3,
      ease: "power2.in",
      overwrite: "auto",
    });
  };

  return (
    <section id="responsibility" className="mb-[8%] font-kumbh overflow-visible w-full scroll-mt-24">
      <div className="mb-6">
        <Marquee text="Responsibility" align="left" />
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-6 overflow-visible">
        <div
          ref={listRef}
          className="relative overflow-visible"
        >
          {responsibilities.map((item, index) => (
            <div
              key={item.number}
              ref={(el) => (rowRefs.current[index] = el)}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={() => handleMouseLeave(index)}
              className="group relative border-b border-[#c8c8c8]/80 opacity-0 translate-y-8 overflow-visible transition-colors duration-300 cursor-pointer"
            >
              {/* Balanced thin hover strip */}
              <div className="absolute inset-x-0 top-4 bottom-4 bg-[#cce2d9] opacity-0 group-hover:opacity-50 transition-all duration-300 ease-in-out pointer-events-none -z-10" />

              {/* 3-Column Responsive Layout Structure */}
              <div className="relative z-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 md:gap-5 py-6 md:py-8 px-4 md:px-7 overflow-visible">
                
                {/* COLUMN 1: Numbers & Title */}
                <div className="w-full md:w-[40%] flex items-center gap-6 shrink-0">
                  <div className="flex items-stretch shrink-0">
                    
                    {/* --- REPLICATED CONTAINER BLOCK START --- */}
                    <div className="relative w-12 h-12 select-none">
                      {/* Teal background shadow layer */}
                      <div className="absolute inset-0 bg-[#00a896] translate-y-[4px] -translate-x-[4px] transition-transform duration-300 group-hover:translate-y-[2px] group-hover:-translate-x-[2px]" />
                      
                      {/* Top Orange block layer holding the number */}
                      <div className="absolute inset-0 bg-[#d9d9d9] flex items-center justify-center text-white text-xl font-black transition-all duration-300 group-hover:bg-[#cc5e15]">
                        {item.number}
                      </div>
                    </div>
                    {/* --- REPLICATED CONTAINER BLOCK END --- */}

                  </div>
                  <h2 className="text-xl md:text-2xl tracking-tight text-[#333]/90 group-hover:text-[#131110] transition-colors duration-300 leading-none">
                    {item.title}
                  </h2>
                </div>

                {/* COLUMN 2: Isolated Center Corridor for the Image */}
                <div className="hidden md:flex items-center justify-center w-[20%] relative h-1 overflow-visible pointer-events-none">
                  <div
                    ref={(el) => (imageRefs.current[index] = el)}
                    className="absolute z-40 pointer-events-none overflow-visible invisible opacity-0 scale-0 origin-center"
                    aria-hidden="true"
                  >
                    <img
                      src={item.img}
                      alt=""
                      className="block w-[200px] lg:w-[250px] max-w-none h-auto aspect-[375/461] object-contain -rotate-3 drop-shadow-[0_12px_24px_rgba(0,0,0,0.16)]"
                      width={375}
                      height={461}
                    />
                  </div>
                </div>

                {/* COLUMN 3: Description Text */}
                <div className="w-full md:w-[40%] flex justify-start md:justify-end">
                  <p className="w-full max-w-[28rem] text-[0.95rem] md:text-[1rem] font-medium leading-[1.5] text-[#555]/90 text-left transition-colors duration-300 group-hover:text-black">
                    {item.description}
                  </p>
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}